<template>
  <base-material-card
    icon="mdi-account-arrow-left-outline"
    :title="groupLabelPlural"
    class="px-5 py-3"
    style="position: relative"
  >
    <v-btn
      color="green"
      dark
      small
      absolute
      top
      right
      fab
      @click.stop="addDialog= true; editedItem.currentTeam = team"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-row style="padding: 20px">
      <v-text-field
        v-model="searchText"
        prepend-inner-icon="mdi-magnify"
        :label="'Search ' + groupLabelPlural.toLowerCase() + ' or admin name'"
        clearable
        dense
        outlined
        style="max-width: 400px"
      />
    </v-row>
    <v-row style="padding: 20px">
      <v-btn
        color="success"
        class="mr-2"
        @click="handleDownload"
      >
        Export to Excel
      </v-btn>
      <v-btn
        color="info"
        class="mr-2"
        @click="handleDownloadTemplate"
      >
        Download Template
      </v-btn>
      <upload-excel-component
        v-if="roles && roles.includes('admin')"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
      />
    </v-row>

    <!-- Bulk action buttons -->
    <v-row v-if="tableSelected.length && roles && roles.includes('hr')" style="padding: 20px">
      <v-btn
        color="success"
        class="mr-2"
        @click="bulkSetActive(true)"
      >
        Set Active
      </v-btn>
      <v-btn
        color="warning"
        class="mr-2"
        @click="bulkSetActive(false)"
      >
        Set Inactive
      </v-btn>
      <v-btn
        color="error"
        class="mr-2"
        @click="bulkDeleteSelected"
      >
        Delete Selected ({{ tableSelected.length }})
      </v-btn>
      <v-btn
        color="primary"
        class="mr-2"
        @click="openBulkParentGroup"
      >
        Set {{ parentGroupLabel }}
      </v-btn>
    </v-row>

    <v-data-table
      v-model="tableSelected"
      :headers="headers"
      show-select
      item-value="id"
      :items="filteredGroups"
      :item-class="itemRowBackground"
    >
      <template
        v-slot:item.isActive="{ item }"
      >
        <v-chip
          :color="item.isActive !== false ? 'success' : 'grey'"
          small
          dark
        >
          {{ item.isActive !== false ? 'Active' : 'Inactive' }}
        </v-chip>
      </template>
      <template
        v-slot:item.action="{item}"
      >
        <Fragment>
          <v-icon

            medium
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>

          <v-icon

            medium
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </Fragment>
      </template>
    </v-data-table>

    <v-dialog
      v-model="addDialog"
      max-width="800"
      persistent
    >
      <v-card :title="'New ' + groupLabel">
        <v-form
          ref="newItemForm"
          @submit.prevent="save(editedItem)"
        >
          <v-container>
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    @input="onNameInput"
                    :rules="[() => !!editedItem.name || 'This field is required']"
                    label="Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.code"
                    :rules="[() => !!editedItem.code || 'This field is required']"
                    label="Code"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-autocomplete
                    v-model="editedItem.currentTeam"

                    clearable

                    :items="teams"
                    label="Default Team"
                    item-text="name"
                    item-value="code"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-autocomplete
                    v-model="editedItem.parentGroupId"

                    clearable

                    :items="groups"
                    :label="parentGroupLabel"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.adminInfo.name"
                    label="Admin Name"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.adminInfo.email"
                    label="Admin Email"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.adminInfo.phone"
                    label="Admin Phone"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-switch
                    v-model="editedItem.isActive"
                    label="Active"
                    :true-value="true"
                    :false-value="false"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click.stop="close">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="parentGroupDialog"
      max-width="500"
      persistent
    >
      <v-card :title="'Set ' + parentGroupLabel">
        <v-form
          ref="parentGroupForm"
          @submit.prevent="bulkSetParentGroup"
        >
          <v-container>
            <v-card-text>
              <v-autocomplete
                v-model="bulkParentGroupId"
                clearable
                :items="groups"
                :label="parentGroupLabel"
                item-text="name"
                item-value="id"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click.stop="parentGroupDialog = false">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  </base-material-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import _ from 'lodash'
  import UploadExcelComponent from '@/components/UploadExcel/index'
  import { M_ADD_GROUP, M_CREATE_MANY_GROUPS, M_DELETE_GROUP, M_UPDATE_GROUP, Q_GET_GROUPS } from '@/gql/group'
  export default {
    name: 'Users',
    components: { UploadExcelComponent },
    data: () => ({
      addDialog: false,
      editedIndex: -1,
      editedItem: { adminInfo:{}, code: ''},
      defaultItem: { adminInfo:{}, isActive: true, code: ''},
      downloading: false,
      filename: '',
      bookType: 'xlsx',
      tableSelected: [],
      searchText: '',
      parentGroupDialog: false,
      bulkParentGroupId: null,

    }),
    computed: {
      ...mapGetters([
        'company', 'teamFull', 'roles', 'user', 'team', 'teams', 'groupLabel', 'parentGroupLabel', 'groupLabelPlural', 'parentGroupLabelPlural',
      ]),
      headers () {
        return [
          // { text: 'ID', value: 'id' },
          { text: this.groupLabel + ' Name', value: 'name' },
          { text: 'Code', value: 'code' },
          { text: 'Team', value: 'currentTeam' },
          { text: this.parentGroupLabel, value: 'computedParentName' },
          { text: 'Admin Name', value: 'adminInfo.name' },
          { text: 'Admin Email', value: 'adminInfo.email' },
          { text: 'Admin Phone', value: 'adminInfo.phone' },
          { text: 'Status', value: 'isActive' },
          { text: 'Actions', value: 'action', sortable: false },
        ]
      },
      groupMap() {
        if (!this.groups) return {}
        return this.groups.reduce((acc, g) => {
          acc[g.id] = g
          return acc
        }, {})
      },
      filteredGroups() {
        if (!this.groups) return []
        if (!this.searchText) {
          return this.groups.map(g => ({
            ...g,
            computedParentName: g.parentGroupId ? this.groupMap[g.parentGroupId]?.name : null
          }))
        }
        const search = this.searchText.toLowerCase()
        return this.groups.filter(g => 
          g.name?.toLowerCase().includes(search) ||
          g.code?.toLowerCase().includes(search) ||
          g.adminInfo?.name?.toLowerCase().includes(search)
        ).map(g => ({
          ...g,
          computedParentName: g.parentGroupId ? this.groupMap[g.parentGroupId]?.name : null
        }))
      },
    },
    methods: {
      onNameInput (val) {
        if (this.editedIndex === -1) {
          this.editedItem.code = val?.toLowerCase().replace(/\s+/g, '') || ''
        }
      },
      itemRowBackground: function (item) {
        return item.isActive === false ? 'inactive' : ''
      },
      handleDownload () {
        this.downloadLoading = true
        this.filename = `Tik ${this.groupLabelPlural} ${this.company} ${this.teamFull && this.teamFull.name}`
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = [this.groupLabel + ' Name', 'Code', 'Team', this.parentGroupLabel, 'Admin Name', 'Admin Email', 'Admin Phone', 'Status']
          const list = this.groups.map(g => ({
            ...g,
            parentGroup: g.parentGroupId ? this.groupMap[g.parentGroupId]?.name : ''
          }))
          const filterVal = ['name', 'code', 'currentTeam', 'parentGroup', 'adminInfo.name', 'adminInfo.email', 'adminInfo.phone', 'isActive']
          const data = this.formatJson(filterVal, _.orderBy(list, ['currentTeam', 'code', 'name'], ['asc', 'desc', 'asc']))
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          })
          this.downloadLoading = false
        })
      },
      handleDownloadTemplate () {
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['Name', 'Code', 'Team', this.parentGroupLabel, 'Admin Name', 'Admin Email', 'Admin Phone']
          const data = []
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: `${this.groupLabelPlural} Template`,
            autoWidth: true,
            bookType: 'xlsx',
          })
        })
      },
      formatJson (filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          if (typeof v[j] === 'number') {
            return +v[j].toFixed(1)
          }
          if (j.includes('.')) {
            const keys = j.split('.')
            let value = v
            for (const key of keys) {
              value = value?.[key]
            }
            return value
          }
          return v[j]
        }))
      },
      normalizePhone (raw) {
        if (!raw) return ''
        let phone = String(raw).trim().replace(/[\s\-()]/g, '')
        if (phone.startsWith('+251')) return phone
        if (phone.startsWith('251')) return '+' + phone
        if (phone.startsWith('0')) return '+251' + phone.slice(1)
        if (phone.startsWith('9')) return '+251' + phone
        if (phone.startsWith('7')) return '+251' + phone
        return '+251' + phone
      },
      handleUploadSuccess ({ results, header }) {
        const groupMap = this.groups.reduce((acc, g) => {
          acc[g.name.toLowerCase()] = g.id
          return acc
        }, {})
        
        const okResults = results.map(r => {
          const row = {}
          for (const key of Object.keys(r)) {
            row[key.toLowerCase()] = r[key]
          }
          const parentLabelKey = this.parentGroupLabel.toLowerCase()
          const parentGroupName = row[parentLabelKey] || row[parentLabelKey.replace(/\s+/g, '')] || row.parentgroup || row['parent group']
          let parentGroupId = null
          if (parentGroupName && groupMap[parentGroupName.toLowerCase()]) {
            parentGroupId = groupMap[parentGroupName.toLowerCase()]
          }
          return {
            name: row.name,
            code: row.code?.toLowerCase().replace(/\s+/g, ''),
            currentTeam: row.team || row.currentteam,
            parentGroupId,
            adminInfo: {
              name: row.adminname || row['admin name'],
              email: row.adminemail || row['admin email'],
              phone: this.normalizePhone(row.adminphone || row['admin phone']),
            },
            isActive: row.isactive !== false && row.status !== 'Inactive',
          }
        })
        this.createGroups(okResults)
      },
      beforeUpload (file) {
        const isLt1M = file.size / 1024 / 1024 < 1

        if (isLt1M) {
          return true
        }
      },
      createGroups (records) {
        this.$apollo.mutate({
          mutation: M_CREATE_MANY_GROUPS,
          variables: {
            records,
          },
          update: (store, { data: { createGroups } }) => {
            const data = store.readQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
            })
            data.groups.push(...createGroups)
            store.writeQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
              data,
            })
          },
          optimisticResponse: {
            __typename: 'Mutation',
            createGroups: {
              records,
            },
          },
        }).then((data) => {
          this.$toast.info(`${records.length} ${this.groupLabelPlural} Imported`)
        }).catch((error) => {
          const message = error.graphQLErrors?.[0]?.message || error.message
          this.$toast.error(message || `Failed to import ${this.groupLabelPlural.toLowerCase()}`)
          console.error(error)
        })
      },
      openBulkParentGroup () {
        this.bulkParentGroupId = null
        this.parentGroupDialog = true
      },
      bulkSetParentGroup () {
        const updates = this.tableSelected.map(item => ({
          id: item.id,
          parentGroupId: this.bulkParentGroupId,
        }))
        Promise.all(
          updates.map(update => this.update(update))
        ).then(() => {
          this.$toast.info(`Set ${this.parentGroupLabel.toLowerCase()} for ${updates.length} ${this.groupLabelPlural.toLowerCase()}`)
          this.parentGroupDialog = false
          this.tableSelected = []
        }).catch(error => {
          this.$toast.error(`Failed to update ${this.groupLabelPlural.toLowerCase()}`)
          console.error(error)
        })
      },
      bulkSetActive (isActive) {        const updates = this.tableSelected.map(item => ({
          id: item.id,
          isActive,
        }))
        Promise.all(
          updates.map(update => this.update(update))
        ).then(() => {
          this.$toast.info(`Set ${isActive ? 'active' : 'inactive'} for ${updates.length} ${this.groupLabelPlural.toLowerCase()}`)
          this.tableSelected = []
        }).catch(error => {
          this.$toast.error(`Failed to update ${this.groupLabelPlural.toLowerCase()}`)
          console.error(error)
        })
      },
      async bulkDeleteSelected () {
        const res = await this.$confirm(
          `Delete ${this.tableSelected.length} selected ${this.groupLabel.toLowerCase()}(s)?`,
          { title: `Bulk Delete ${this.groupLabelPlural}` },
        )
        if (!res) return

        let deletedCount = 0
        for (const item of this.tableSelected) {
          try {
            await this.$apollo.mutate({
              mutation: M_DELETE_GROUP,
              variables: { where: { id: item.id } },
              update: (store, { data: { deleteGroup } }) => {
                const data = store.readQuery({
                  query: Q_GET_GROUPS,
                  variables: { where: { or: [{ currentTeam: this.team }, { currentTeam: null }] } },
                })
                data.groups = data.groups.filter(t => +t.id !== +item.id)
                store.writeQuery({
                  query: Q_GET_GROUPS,
                  variables: { where: { or: [{ currentTeam: this.team }, { currentTeam: null }] } },
                  data,
                })
              },
              optimisticResponse: {
                __typename: 'Mutation',
                deleteGroup: { id: item.id },
              },
            })
            deletedCount++
          } catch (e) {
            console.error(`Failed to delete group ${item.name || item.id}`, e)
          }
        }
        this.$toast.info(`Deleted ${deletedCount} of ${this.tableSelected.length} ${this.groupLabel.toLowerCase()}(s)`)
        this.tableSelected = []
      },
      createMany (records) {
        this.$apollo.mutate({
          mutation: M_CREATE_MANY_GROUPS,
          variables: {
            records,
          },
          update: (store, { data: { createGroups } }) => {
            const data = store.readQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
            })
            data.groups.push(...createGroups)
            store.writeQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
              data,
            })
          },
          // Optimistic UI
          // Will be treated as a 'fake' result as soon as the request is made
          // so that the UI can react quickly and the user be happy
          optimisticResponse: {
            __typename: 'Mutation',
            createGroups: {
              records,
            },
          },
        }).then((data) => {
          // this.selected = []

          this.$toast.info(`${records.length} New Items Added`)
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          console.error(error)
          this.$toast.error('Something went wrong when add new items')
        // We restore the initial user input
        // this.editedItem = m
        })
      },
      createOne (item) {
        this.$apollo.mutate({
          mutation: M_ADD_GROUP,
          variables: {
            ...item
          },
          update: (store, { data: { createGroup } }) => {
            const data = store.readQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
            })

            data.groups = [...data.groups, createGroup]

            store.writeQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
              data,
            })

          },

          optimisticResponse: {
            __typename: 'Mutation',
            createGroup: {
              id: 9999,
              code: ' ',
              currentTeam: this.team,
              isActive: true,
              ...item,
              __typename: 'Group',
            },
          },
        }).then((data) => {
          // this.selected = []
          this.$toast.info('New Record Added')
        // Result
        //  console.log(data)
        }).catch((error) => {
          // Error
          this.$toast.error('Something went wrong when adding a record')

        // We restore the initial user input
        // this.editedItem = m
        })
      },
      update (item) {
        item.id = +item.id
        this.$apollo.mutate({
          mutation: M_UPDATE_GROUP,
          variables: { ...item },
          update: (store, { data: { updateGroup } }) => {
            if (updateGroup) {
              const data = store.readQuery({
                query: Q_GET_GROUPS,
                variables: {
                  where: {
                    or: [
                      { currentTeam: this.team },
                      { currentTeam: null },
                    ],
                  },
                },
              })

              const itemX = data.groups.find(t => +t.id === updateGroup.id)

              for (const key of Object.keys(updateGroup)) {
                itemX[key] = updateGroup[key]
              }

              store.writeQuery({
                query: Q_GET_GROUPS,
                variables: {
                  where: {
                    or: [
                      { currentTeam: this.team },
                      { currentTeam: null },
                    ],
                  },
                },
                data,
              })
            }
          },
          optimisticResponse: {
            __typename: 'Mutation',
            updateGroup: {
              __typename: 'Group',
              ...item,
            },
          },

        }).then(d => {
          this.$toast.info('Record Updated')
        // this.selected = []
        }).catch((error) => {
          // console.log('updateE',error)
          this.$toast.error('Sorry,failed to update the record')
        })
      },
      deleteOne (id) {
        this.$apollo.mutate({
          mutation: M_DELETE_GROUP,
          variables: {
            where: { id },
          },
          update: (store, { data: { deleteGroup } }) => {

            const data = store.readQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
            })
            data.groups = data.groups.filter(t => {
              return +t.id !== id
            })
            store.writeQuery({
              query: Q_GET_GROUPS,
              variables: {
                where: {
                  or: [
                    { currentTeam: this.team },
                    { currentTeam: null },
                  ],
                },
              },
              data,
            })
          },
          optimisticResponse: {
            __typename: 'Mutation',
            deleteGroup: {
              id,
            },
          },
        },
        ).then(() => {
          this.$toast.info('Record Deleted')
        //  this.selected = []
        })
      },
      close () {
        this.addDialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      editItem (item) {
        this.editedIndex = item.id ? this.groups.findIndex(g => g.id === item.id) : -1
        this.editedItem = {...item, adminInfo: item.adminInfo||{}, code: item.code?.toLowerCase().replace(/\s+/g, '') || ''}
        this.addDialog = true
      },
      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.deleteOne(+item.id)
      },
      save (item) {
        if (item.code) {
          item.code = item.code.toLowerCase().replace(/\s+/g, '')
        }
        this.close()
        if (this.editedIndex > -1) {
          this.update(item)
        } else {
          this.createOne(item)
        }
      },

    },
    apollo: {
      groups: {
        query: Q_GET_GROUPS,
        variables () {
          return {
            where: {
              or: [
                { currentTeam: this.team },
                { currentTeam: null },
              ],
            },
          }
        },
      },

    },

  }
</script>

<style   >
.inactive {
  /*background-color: rgb(215,215,44);*/
  text-decoration: line-through !important;
}
</style>
